<template>
    <div class="accordion"  >
        <div class="header" v-bind:class="{ borderBottom: !show }" v-on:click="toggle">
            <slot name="header">{{question}}</slot>
            <i class="fa fa-2x fa-angle-down header-icon" style="color: white;" v-bind:class="{ rotate: show }"></i>
        </div>
        <transition
            name="accordion"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:before-leave="beforeLeave"
            v-on:leave="leave"
        >
            <div class="body" v-show="show">
                <div class="body-inner">
                    <slot><p style="padding:10px">{{answer}}</p></slot>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>

export default {
    name: 'FAQ',


    props: {
        question: {
            type: String,
            required: true,
        },

        answer: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            show: false,
        };
    },

    methods: {
        toggle() {
            this.show = !this.show;
        },
        beforeEnter(el) {
            el.style.height = '0';
        },
        enter(el) {
            // eslint-disable-next-line
            el.style.height = el.scrollHeight + 'px';
        },
        beforeLeave(el) {
            // eslint-disable-next-line
            el.style.height = el.scrollHeight + 'px';
        },
        leave(el) {
            el.style.height = '0';
        },
    },
};
</script>
<style lang="scss" scoped>
.accordion {
    margin-bottom: 10px;
    border-radius: 6px;
}

.accordion .header {
    height: 40px;
    line-height: 40px;
    padding: 0 40px 0 8px;
    position: relative;
    color: #fff;
    cursor: pointer;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    font-weight: 700;
}

.accordion .header-icon {
    position: absolute;
    top: 5px;
    right: 8px;
    transform: rotate(0deg);
    transition-duration: 0.3s;
}

.accordion .body {
    /*   display: none; */
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #2C4155;
    border-top: 0;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    transition: 150ms ease-out;
}

.accordion .body-inner {
    padding: 8px;
    overflow-wrap: break-word;
    /*   white-space: pre-wrap; */
}

.accordion .header-icon.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
}

.borderBottom {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}
</style>
